import React from 'react'
import { Subject } from '@reactivex/rxjs'
import Selected from './Selected'
import { partialRight } from 'ramda'
import { render } from 'react-dom'

const domSink = partialRight(render, [document.getElementById('root')])

const toView = snapshot => (<Selected selected={snapshot.get('selected')} />)

export const render$ = new Subject()

render$.map(toView).subscribe(domSink)



// WEBPACK FOOTER //
// ./view.js